import { Link } from 'react-router-dom';
import { endpoints } from '@/api/endpoints';
import { useApi } from '@/api/useApi';
import { LoadingState, EmptyState } from '@/components/EmptyState';
import { ErrorBanner } from '@/components/ErrorBanner';
import { StatusBadge } from '@/components/StatusBadge';
import { RequirePermission } from '@/components/RequirePermission';
import { useLanguage } from '@/i18n/LanguageContext';
import { formatDateTime } from '@/i18n/format';

export function ImportsListPage(): JSX.Element {
  const result = useApi(() => endpoints.imports(), []);
  const { t, locale } = useLanguage();

  return (
    <div>
      <div className="page-header">
        <h1>{t('nav.imports')}</h1>
        <RequirePermission permission="IMPORT.WRITE">
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Link to="/imports/new?mode=excel">
              <button type="button">{t('imports.fromExcel')}</button>
            </Link>
            <Link to="/imports/new">
              <button type="button" className="primary">
                {t('imports.newImport')}
              </button>
            </Link>
          </div>
        </RequirePermission>
      </div>

      {result.status === 'loading' && <LoadingState />}
      {result.status === 'error' && <ErrorBanner error={result.error} onRetry={result.reload} />}
      {result.status === 'success' &&
        (result.data.batches.length === 0 ? (
          <EmptyState title={t('imports.emptyTitle')} hint={t('imports.emptyHint')} />
        ) : (
          <div className="table-scroll"><table>
            <thead>
              <tr>
                <th>{t('imports.colFile')}</th>
                <th>{t('imports.colType')}</th>
                <th>{t('common.status')}</th>
                <th>{t('imports.colRows')}</th>
                <th>{t('imports.colCreated')}</th>
              </tr>
            </thead>
            <tbody>
              {result.data.batches.map((b) => (
                <tr key={b.id} onClick={() => (window.location.href = `/imports/${b.id}`)}>
                  <td>{b.file_name}</td>
                  <td>{b.entity_kind}</td>
                  <td>
                    <StatusBadge value={b.status ?? (b as Record<string, unknown>).state as string} />
                  </td>
                  <td>{JSON.stringify((b as Record<string, unknown>).stats ?? {})}</td>
                  <td>{formatDateTime(b.created_at, locale)}</td>
                </tr>
              ))}
            </tbody>
          </table></div>
        ))}
    </div>
  );
}
